//message should minimally have a type attribute
export const postIframeData = (message) => {
    const isInIframe =
      typeof self !== 'undefined' && typeof top !== 'undefined' && self !== top;
  
    if (!isInIframe) {
      console.log(
        'Not in an iframe. Refusing to send postMessage data of',
        message,
      );
      return;
    }
  
    console.log('Sending postMessage to parent iframe', message);
    window.parent.postMessage(
      message,
      '*' /*
          '*' means a wildcard origin (any origin).
  
          This sends it to parent iframe regardless of origin because that way localhost testing can work.
  
          TODO: We could restrict this in future.
  
          The only attack scenario that I (SpringLoaded Andrew) know of is that another tab in the same user's browser is able to snoop on the data...but that seems unlikely.
  
          It may be the case that window.parent.postMessage limits messages only to the parent iframe and not all tabs too. MDN docs are unclear.
  
          https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
  
        */,
    );
  };